import React, { useEffect, useState } from "react";
import Label from "./fromLabel";
import Error from "./fromError";
import Icon from "../../icons";

interface InputProps {
  type?: "text" | "password" | "email" | "number" | "tel";
  placeholder?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  info?: string;
  error?: string;
  className?: string;
  inputClassName?: string;
  size?: "sm" | "md" | "lg";
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  step?: number;
  min?: number;
  name?: string;
  maxLength?: number;
  ref?: React.Ref<any>;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBeforeInput?: (e: any) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  hideErrorMessage?: boolean;
  prefix?: string;
  autoComplete?: string;
}


const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  type = "text",
  placeholder,
  value,
  size = "md",
  onChange,
  className = "",
  inputClassName = "",
  disabled = false,
  label,
  required,
  info,
  error,
  onKeyDown,
  children,
  step,
  min,
  name,
  maxLength,
  onKeyUp,
  onBeforeInput,
  onBlur,
  hideErrorMessage = false,
  prefix,
  autoComplete,
}, ref) => {
  const [visible, setVisible] = useState<boolean>(false);
  return (
    <div className={`my-6 ${className}`}>
      {label && <Label text={label} required={required} info={info} isElipsis />}
      <div className="relative">
        {prefix && (
          <span className={`absolute pointer-events-none text-[#222222] top-1/2 -translate-y-1/2 ${
            size === "sm"
              ? "left-2 text-[0.667rem]"
              : size === "lg"
              ? "left-4 text-[18px] mt-2"
              : "left-3 text-[0.938rem] mt-1"
          }`}>
            {prefix}
          </span>
        )}
        <input
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onBeforeInput={onBeforeInput}
          onBlur={onBlur}
          type={visible ? "text" : type}
          placeholder={placeholder}
          value={value != undefined ? value : ""}
          onChange={onChange}
          disabled={disabled}
          maxLength={maxLength || undefined}
          step={step}
          min={min}
          name={name}
          autoComplete={autoComplete}
          ref={ref}
          className={` ${
            error ? "border-red-500 border-2" : "border-[#CECECE] border"
          } rounded-md focus:outline-none  focus:primary ${
            size == "sm"
              ? `text-[0.667rem] mt-0 ${prefix ? "pl-4" : "pl-2"} py-1  font-normal h-[2rem]`
              : (size == 'lg'?`text-[18px] mt-2 ${prefix ? "pl-8" : "pl-4"} py-2  font-normal h-[80px] !rounded-[3px]`:`text-[0.938rem] mt-2 ${prefix ? "pl-7" : "pl-4"} py-2  font-normal h-[2.875rem]`)
          } text-[#222222] placeholder:text-[#a1a1a1] w-full  ${inputClassName}`}
        />
        {type == "password" && (
          <span
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer mt-1"
            onClick={() => setVisible((v) => !v)}
          >
            <Icon className="" size={30} name={visible ? "eye-closed" : "eye"} />
          </span>
        )}
        {children}
      </div>

      {/* {typeof value === "string" && maxLength && value.length >= maxLength && (
        <div className="text-xs text-red-600 mt-1 text-left">
          Max limit reached
        </div>
      )} */}
      
      {error && !hideErrorMessage && <Error message={error} />}
    </div>
  );
});

export default Input;
